import { Stars } from '../../CustomerReviews/Stars'

export const Ratings = (props: RatingsProps) => {
  if (!props.averageRating || !props.reviewsCount) return null

  return (
    <div className="flex items-center">
      <Stars rating={props.averageRating} />
      <a
        href="#customer-reviews"
        className="flex-1 text-sm ml-2 underline text-vi-red cursor-pointer hover:no-underline"
      >
        {props.reviewsCount} reviews
      </a>
    </div>
  )
}

interface RatingsProps {
  averageRating?: number
  reviewsCount?: number
}
